module.exports = __webpack_public_path__ + "static/media/1.c67adb8e.png";